import { C, cScale } from './complex';

/**
 * Grover's search operator, applied directly to the state vector (the
 * oracle and diffusion operator are each genuinely unitary — this is the
 * standard way they're presented in an exposition, rather than decomposing
 * them into elementary 1-/2-qubit gates, but the math is exact either way).
 */

// Oracle: flip the sign of the marked item's amplitude, leave everything else untouched.
export const groverOracle = (state, markedIndex) =>
  state.map((amp, i) => (i === markedIndex ? cScale(amp, -1) : amp));

// Diffusion operator D = 2|s><s| - I, i.e. inversion about the mean amplitude.
export const groverDiffusion = (state) => {
  const n = state.length;
  let sumRe = 0, sumIm = 0;
  for (const a of state) { sumRe += a.re; sumIm += a.im; }
  const meanRe = sumRe / n, meanIm = sumIm / n;
  return state.map((amp) => C(2 * meanRe - amp.re, 2 * meanIm - amp.im));
};

export const groverIteration = (state, markedIndex) => groverDiffusion(groverOracle(state, markedIndex));

// Run k full Grover iterations starting from the given state, returning the
// state after each iteration (index 0 = before any iterations).
export const runGrover = (initialState, markedIndex, iterations) => {
  const history = [initialState];
  let state = initialState;
  for (let i = 0; i < iterations; i++) {
    state = groverIteration(state, markedIndex);
    history.push(state);
  }
  return history;
};
